__turbopack_context__.v({
  "animate-wobble-hor-bottom": "InputDecorator-module-scss-module__sqDWRW__animate-wobble-hor-bottom",
  "fade-in": "InputDecorator-module-scss-module__sqDWRW__fade-in",
  "fade-in-bottom": "InputDecorator-module-scss-module__sqDWRW__fade-in-bottom",
  "fade-in-top": "InputDecorator-module-scss-module__sqDWRW__fade-in-top",
  "fade-out": "InputDecorator-module-scss-module__sqDWRW__fade-out",
  "fade-out-bottom": "InputDecorator-module-scss-module__sqDWRW__fade-out-bottom",
  "fade-out-top": "InputDecorator-module-scss-module__sqDWRW__fade-out-top",
  "flip-in-ver-left": "InputDecorator-module-scss-module__sqDWRW__flip-in-ver-left",
  "scale-in-center": "InputDecorator-module-scss-module__sqDWRW__scale-in-center",
  "scale-in-tl": "InputDecorator-module-scss-module__sqDWRW__scale-in-tl",
  "scale-in-top": "InputDecorator-module-scss-module__sqDWRW__scale-in-top",
  "scale-in-ver-center": "InputDecorator-module-scss-module__sqDWRW__scale-in-ver-center",
  "scale-out-top": "InputDecorator-module-scss-module__sqDWRW__scale-out-top",
  "scale-up-center": "InputDecorator-module-scss-module__sqDWRW__scale-up-center",
  "shake-horizontal": "InputDecorator-module-scss-module__sqDWRW__shake-horizontal",
  "slide-in-bottom": "InputDecorator-module-scss-module__sqDWRW__slide-in-bottom",
  "slide-in-fwd-center": "InputDecorator-module-scss-module__sqDWRW__slide-in-fwd-center",
  "slide-in-left": "InputDecorator-module-scss-module__sqDWRW__slide-in-left",
  "slide-in-right": "InputDecorator-module-scss-module__sqDWRW__slide-in-right",
  "slide-in-top": "InputDecorator-module-scss-module__sqDWRW__slide-in-top",
  "slide-out-bottom": "InputDecorator-module-scss-module__sqDWRW__slide-out-bottom",
  "slide-out-left": "InputDecorator-module-scss-module__sqDWRW__slide-out-left",
  "slide-out-right": "InputDecorator-module-scss-module__sqDWRW__slide-out-right",
  "slide-out-top": "InputDecorator-module-scss-module__sqDWRW__slide-out-top",
  "swing-in-top-fwd": "InputDecorator-module-scss-module__sqDWRW__swing-in-top-fwd",
  "tilt-in-fwd-tr": "InputDecorator-module-scss-module__sqDWRW__tilt-in-fwd-tr",
  "validation-message": "InputDecorator-module-scss-module__sqDWRW__validation-message",
  "wobble-hor-bottom": "InputDecorator-module-scss-module__sqDWRW__wobble-hor-bottom",
});
